export default class StrictMap<TKey, TValue> extends Map<TKey, TValue> {
  find(key: TKey) {
    if (!this.has(key)) throw new Error(`No item for key ${key}`);
    return this.get(key) as TValue;
  }
}
